import { ChatModuleType } from 'app/copied/models/ChatModules';

import { useLiveChatModuleAvailable } from './useLiveChatModuleAvailable';
import useModule from './useModule';
import { useOfflineModulesAvailable } from './useOfflineModulesAvailable';

export default function useLandingRoute() {
  const offlineModulesAvailable = useOfflineModulesAvailable();
  const liveChatAvailable = useLiveChatModuleAvailable();
  const vaModule = useModule(ChatModuleType.VirtualAssistant);

  const landingRoute =
    liveChatAvailable && !offlineModulesAvailable
      ? '/live-chat'
      : vaModule?.va_as_landing_page_enabled
        ? '/virtual-assistant'
        : '/tailor';

  return landingRoute;
}
